import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const BookmarkBold: FC<Props> = ({ fill, ...otherProps }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...otherProps}
     aria-label="bookmark icon">
      {/* <title>bookmark icon</title> */}
      <path
        d="M4.67058 21.094C4.93258 21.356 5.28058 21.5 5.65158 21.5C5.88558 21.5 6.12058 21.44 6.32858 21.323L12.0256 18.13L17.6676 21.316C17.9906 21.498 18.3636 21.545 18.7196 21.444C19.0766 21.345 19.3726 21.113 19.5526 20.793C19.6696 20.584 19.7326 20.349 19.7326 20.112L19.7266 6.586C19.7266 3.951 18.0326 2.5 14.9566 2.5H9.03958C6.00658 2.5 4.26758 3.927 4.26758 6.415V20.116C4.26658 20.485 4.41058 20.832 4.67058 21.094Z"
        fill={fill || "currentColor" || "black"}
      />
    </svg>
  );
};

export default BookmarkBold;
